<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7PRVUW/tc-custom/9780804792271.jpg?1705037438407" alt="This image is the cover for the book Boom Towns"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boom Towns
      </h1>
      <p class="bookDescription body article font2">
        <b>An economist examines the decline of American cities and offers a strategy for their rejuvenation based on respect for property rights.</b><br/><br/>American cities, once centers of opportunity, are all too often plagued by poverty and decay. One need only look at the ruins of Detroit to see how far some cities have fallen. Yet other examples, like Boston and San Francisco, show that such a fate is reversible. In <i>Boom Towns</i>, Stephen J.K. Walters diagnoses the root causes of urban decline in order to prescribe remedies that will enable cities to thrive once again. <br/><br/>Using vivid evocations of iconic towns and the people who helped shape their development, Walters shows how public revitalization policies often do more harm than good. He then outlines a more promising set of policies to remedy the capital shortage that continues to afflict many cities and needlessly limit their residents’ opportunities. With its fresh interpretation of one of the American quandaries of our day, <i>Boom Towns</i> offers a novel contribution to the debate about American cities and a program for their restoration.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen J.K. Walters
      </h2>
      
      <p class="authorDescription body article">Stephen J.K. Walters is Professor of Economics at Loyola University Maryland and a Fellow at the Johns Hopkins Institute for Applied Economics, Global Health, and the Study of Business Enterprise. He has advised aspiring and elected mayors and governors, given expert testimony in antitrust and tort cases, and consulted for diverse clients, ranging from the Nuclear Regulatory Commission to major league baseball clubs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stanford University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5289203b